import { useCallback, useEffect, useRef } from 'react';
import classnames from 'classnames/bind';

import { CheckCircleIcon, CloseCircleIcon } from '@autopass-web/mochi-icons';

import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface props {
  type: '' | 'success' | 'failure';
  show: boolean;
  autoDismiss: boolean;
  onDismiss: () => void;
  message: string;
}

const AppMessage = ({
  type = '',
  show = false,
  autoDismiss = true,
  onDismiss = () => undefined,
  message,
}: props) => {
  const dismissTimeoutHandler = useRef<ReturnType<typeof setTimeout>>();

  const IconImg = ({ type }: { type: string }) => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon width={60} height={60} />;
      case 'failure':
        return <CloseCircleIcon width={60} height={60} />;
      default:
        return null;
    }
  };

  const dismissHandler = useCallback(() => {
    if (autoDismiss) {
      clearTimeout(dismissTimeoutHandler.current);
      onDismiss();
    }
  }, [onDismiss, autoDismiss]);

  useEffect(() => {
    if (show && autoDismiss) {
      dismissTimeoutHandler.current = setTimeout(dismissHandler, 3000);
    }
  }, [show, dismissHandler, autoDismiss]);

  const appMessageClasses = cx({
    'app-message': true,
    [type]: true,
    show,
  });

  return (
    <div className={appMessageClasses} onClick={dismissHandler}>
      <div className={styles['inner-container']}>
        <IconImg type={type} />
        {message}
      </div>
    </div>
  );
};

export default AppMessage;
